import { store } from '../store/storeMain'
import { transactionManager } from './transactionManager'

export const incomeManager = {
  incomes:[],

  incomeObject: {
    id: 0,
    incomeName: '',
    account: '',
    incomeType: '',
    amount: 0,
    incomeAmount: 0,
    currencyConversion: {},
    currency: '',
    incomeDate: '',
    incomeTime: '',
    comment: '',
    category: '',

    //Recurring
    repeat: 1,
    cycle: '',
    period: '',
    numberOfCycles: 1,
    goesOffFirst: '',

    //State of Current Object
    objectState: 'New',
    show: false
  },

  getIncome() {
    this.incomes = store.state.Incomes
  },

  addIncome(income) {
    let newEntry = JSON.parse(JSON.stringify(income))

    this.addDialog = false

    newEntry.id = this.getLargestIdFromItems() + 1

    this.addIncomeToStore(newEntry)
  },

  getLargestIdFromItems() {
    this.getIncome()

    let largest = 0
    for (let i = 0; i < this.incomes.length; i++) {
      if (this.incomes[i].id > largest) {
        largest = this.incomes[i].id
      }
    }
    return largest
  },

  addIncomeToStore(newEntry) {
    store.commit('addNewIncomeToStore', newEntry)
  },

  createTransactionFromIncome(income) {
    let transaction = this.convertIncomeToTransaction(income)

    transactionManager.addTransaction(transaction)
  },

  convertIncomeToTransaction(income) {
    let transaction = transactionManager.transactionObject

    //Replace Data from Income
    transaction.account = income.account
    transaction.transactionName = income.incomeName
    transaction.transactionType = 'income'
    transaction.transactionAmount = income.incomeAmount
    transaction.comment = income.comment
    transaction.currency = income.currency
    transaction.category = income.category
    transaction.transactionDate = income.incomeDate
    transaction.transactionTime = income.incomeTime

    if (income.incomeType === "Recurring") {
      transaction.recurringTransaction = true
    }
    else if (income.incomeType === "OneTime") {
      transaction.recurringTransaction = false
    }

    transaction.repeat = income.repeat
    transaction.cycle = income.cycle
    transaction.period = income.period
    transaction.numberOfCycles = income.numberOfCycles
    transaction.goesOffFirst = income.goesOffFirst
    transaction.objectState = income.objectState


    return transaction
  },

  updateTransactionFromIncome(income) {
    let oldTransaction = transactionManager.getTransactionByName(income.incomeName)

    let newTransaction = this.convertIncomeToTransaction(income)

    transactionManager.updateTransaction(oldTransaction, newTransaction)
  },

  rollbackTransactionFromIncome(income) {
    income.objectState = 'Delete'

    this.updateTransactionFromIncome(income)

  },

  createIncomeFromTrasaction(transaction) {
    let newIncome = this.convertTransactionToIncome(transaction)

    this.addIncome(newIncome)
  },

  convertTransactionToIncome(transaction) {
    let income = this.incomeObject
    
    income.account = transaction.account
    income.incomeName = transaction.transactionName 
    //transaction.transactionType = 'income'
    income.incomeAmount = transaction.transactionAmount
    income.comment = transaction.comment 
    income.category = transaction.category
    income.currency = transaction.currency
    income.incomeDate = transaction.transactionDate
    income.incomeTime = transaction.transactionTime 

    if (transaction.recurringTransaction) {
      income.incomeType === "Recurring"
    }
    else if (!transaction.recurringTransaction) {
      income.incomeType === "OneTime"
    }

    income.repeat = transaction.repeat 
    income.cycle = transaction.cycle 
    income.period = transaction.period 
    income.numberOfCycles = transaction.numberOfCycles 
    income.goesOffFirst = transaction.goesOffFirst
    income.objectState = transaction.objectState 

    return income
  }

}



// WEBPACK FOOTER //
// ./src/javascript/incomeManager.js